import React from 'react'
import "../articles.css"

import rodolfo from "../../../../assets/images/articles/elec.jpg"
import { Byline, Published } from "../.."

export default function Article3Doc() {
  return (
    <div className='emas__articles'>
    <div className='emas__articles-container'>
        <img className="emas__articles-container_headImage" src={rodolfo} alt="rodolfo"></img>
        <div className='emas__articles-container_photo'>
          <i >Photo by Johannes Plenio: https://www.pexels.com/photo/photography-of-electrical-towers-in-the-field-1133500/</i>
        </div>
        <h1>Policy priorities for the WEM</h1>
        <div className='emas__articles-container_publish'>
          <p></p>
        </div>
        <div className='emas__articles-container_body'>
              
        </div>
        <Published />
    </div>
</div>
  )
}
